import axios from "axios";

const HOST_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" ? `${window.location.origin}/api` : "/api");

const axiosInstance = axios.create({
  baseURL: HOST_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "tenant-host": typeof window !== "undefined" ? window.location.hostname : "",
  },
});

const getAuthToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return localStorage.getItem("authToken");
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      const pathname = typeof window !== "undefined" ? window.location.pathname : "";
      const isPublicPage =
        pathname === "/login" ||
        pathname.startsWith("/receipt") ||
        pathname.startsWith("/transactions/anonomous");

      if (!isPublicPage && typeof window !== "undefined") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
